module.exports = __webpack_public_path__ + "4cb02205cd8c5df40258288c72d5b656.pdf";